import { UseAxiosResult } from "axios-hooks";
import { PasswordOptions } from "shared";
import formatUrl from "utils/formatUrl";

import api from "config/urls/api";

import { UserLoginRedirect } from "./login";
import { UseSelectUserManagementApi } from "./setup";

export interface InviteValidation {
  requiresConsent: boolean;
  isValid: boolean;
  isInvalidUser: boolean;
  userExists: boolean;
  errorMessage?: string;
  inviteEmail: string;
  inviteUserName?: string;
}

export const validateInvite = (
  inviteId: string,
  validateUser: boolean
): UseAxiosResult<InviteValidation> => {
  return UseSelectUserManagementApi<InviteValidation>({
    url: formatUrl(api.invite.validate, { inviteId }),
    method: "GET",
    params: { validateUser },
  });
};

export const useRegisterUser = (
  inviteId: string,
  redirectUrl?: string
): UseAxiosResult<UserLoginRedirect> => {
  return UseSelectUserManagementApi<UserLoginRedirect>(
    {
      url: formatUrl(api.invite.register, { inviteId }),
      method: "POST",
      params: { redirectUrl },
    },
    {
      manual: true,
    }
  );
};

export const useGetRegisterPasswordOptions = (
  inviteId: string
): UseAxiosResult<PasswordOptions> => {
  return UseSelectUserManagementApi<PasswordOptions>({
    url: formatUrl(api.invite.passwordOptions, { inviteId }),
    method: "GET",
  });
};
